import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { ApiConfigService } from './api-config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
    LookupResponseModel,
    LookupItemModel,
    ApiResponse
} from '../models';

/**
 * Lookup API Service - Handles reference data and dropdowns
 */
@Injectable({
    providedIn: 'root'
})
export class LookupService extends BaseApiService {


    /**
     * Get materials lookup
     */
    getMaterials(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/materials');
    }

    /**
     * Get types lookup
     */
    getTypes(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/types');
    }

    /**
     * Get gasket materials lookup
     */
    getGasketMaterials(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/gasket-materials');
    }

    /**
     * Get PVC-U materials lookup
     */
    getPvcUMaterials(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/pvc-u-materials');
    }

    /**
     * Get countries lookup
     */
    getCountries(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/countries');
    }

    /**
     * Get applications lookup
     */
    getApplications(): Observable<ApiResponse<LookupItemModel[]>> {
        return this.get<LookupItemModel[]>('/lookup/applications');
    }
}
